export default Object.freeze({
  PLACEHOLDER_SELECT: "選択してください",
  PLACEHOLDER_INPUT: "入力してください",
  PLACEHOLDER_FILE: "ファイルを選択してください",
  PLACEHOLDER_SELECT_DATE: "日付を選択してください",
  PLACEHOLDER_LOGIN_ID: "国/自治体から決まります",
  PLACEHOLDER_NAME: "例：鹿児島 太郎",
  PLACEHOLDER_KANA_NAME: "例：カゴシマ タロウ",
  PLACEHOLDER_BIRTH: "例）1999/02/12",
  PLACEHOLDER_BIRTH_YYYYMMDD: "例: 19990212",
  PLACEHOLDER_POST_NUMBER: "7桁で入力してください",
  PLACEHOLDER_ADDRESS: "例：鹿児島市ＸＸ１－１－１",
  PLACEHOLDER_VUL_REASON: "例）車いす利用／寝たきり／要介護度",
  PLACEHOLDER_SP: " ",
  DATETIME_BUTTON_TEXT_OK: "確定",
  DATETIME_BUTTON_TEXT_CLEAR: "クリア",
  DATETIME_FORMAT_YYYYMMDDHHMMSS: "YYYYMMDDHHmmss",
  DATETIME_FORMAT_YYYYMMDDHHMM00: "YYYYMMDDHHmm00",
  DATETIME_FORMAT_YYYYMMDDHHMM00_WITH_SLASH: "YYYY/MM/DDHHmm00",
  DATETIME_FORMAT_YYYYMMDDHHMM_WITH_SLASH_COLON: "YYYY/MM/DD HH:mm",
  DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON: "YYYY/MM/DD HH:mm:ss",
  DATETIME_FORMAT_YYYYMMDD000000_WITH_SLASH_COLON: "YYYY/MM/DD 00:00:00",
  DATETIME_FORMAT_YYYYMMDDHHMMSS00_WITH_HYPHEN_COLON: "YYYY-MM-DD HH:mm:ss.00",
  DATETIME_FORMAT_YYYYMMDDHHMM00_WITH_SLASH_COLON: "YYYY/MM/DD HH:mm:00",
  DATETIME_FORMAT_YYYYMMDDHHMM00_WITH_HYPHEN_COLON: "YYYY-MM-DD HH:mm:00",
  DATE_FORMAT_YYYYMMDD: "YYYYMMDD",
  DATE_FORMAT_YYYYMMDD_WITH_HYPHEN: "YYYY-MM-DD",
  DATE_FORMAT_YYYYMMDD_WITH_SLASH: "YYYY/MM/DD",
  TIME_FORMAT_HH: "HH",
  TIME_FORMAT_MM: "mm",
  FILE_INPUT_ACCEPT:
    ".png,.gif,.jpeg,.jpg,.txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx",
  HINT_TEL: "ハイフン(-)を入れずに入力してください",
  HINT_TEL_AND_EXTENSION_WITH_HYPHEN:
    "ハイフン(-)ありで入力してください。例:0996-27-xxxx(8888)"
});
